import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './JoinVodaPayClub.css';
import TagIcon from '../../assets/TagIcon.jsx';
import PercentIcon from '../../assets/PercentIcon.jsx';
import MerchantIcon from '../../assets/MerchantIcon.jsx';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import VodaPayClubTicket from '../../assets/VodaPayClubTicket.jsx';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import { UpdateSnackBarContext } from '../../services/context/SnackBarContext.js';
import FailIcon from '../../assets/FailIcon.jsx';
import { defaultAnalyticsVariables, events, pagePrefix } from '../../services/Constants/Analytics.js';
import useNormalizedSubscriptionStatus from '../../services/utils/subscriptionUtils.js';
/**
 * @returns {JSX.Element} JoinVodaPayClub Component
 */
export default function JoinVodaPayClub() {
  const navigateTo = useNavigate();
  const analyticsName = `${pagePrefix}: join vodapay club`;
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const setSnackBar = useContext(UpdateSnackBarContext);
  const subscriptionStatus = !subscriptionDetails?.isSubscribed && subscriptionDetails?.isEligibleToSubscribe;

  const subscriptionStatusAnalytics = useNormalizedSubscriptionStatus();
  const buttonText = subscriptionDetails?.plans?.length === 1 ? 'Subscribe' : 'See available plans';
  const buttonCss = subscriptionDetails?.plans?.length === 1 ? 'joinClub-button' : 'billing-frequency-button';

  useEffect(() => {
    window.utag?.view({
      ...defaultAnalyticsVariables,
      event_name: [events.pageView],
      page_name: analyticsName,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatusAnalytics}`,
    });
  });

  const onClickAnalytics = () => {
    window.utag?.link({
      ...defaultAnalyticsVariables,
      event_name: [events.interaction],
      page_name: analyticsName,
      link_id: `${pagePrefix}: see available plans`,
      visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatusAnalytics}`,
    });
  };

  const handleContinue = status => {
    if (status && subscriptionDetails?.plans?.length === 1) {
      navigateTo(ROUTES.SUB_SUMMARY, { state: { selectedPlan: subscriptionDetails?.plans[0] } });
    } else if (status && subscriptionDetails?.plans?.length > 1) {
      navigateTo(ROUTES.SUBS_PLAN_PAGE);
    } else {
      setSnackBar({
        icon: <FailIcon />,
        body: 'Service unavailable now. Please try again.',
      });
      window.utag?.link({
        ...defaultAnalyticsVariables,
        event_name: [events.interaction],
        event_error_name: 'Service unavailable now. Please try again.',
        page_name: analyticsName,
        link_id: `${pagePrefix}: see available plans`,
        visitor_addon_type_active: `${defaultAnalyticsVariables.app_name}: subscription: ${subscriptionStatusAnalytics}`,
      });
    }
  };

  return (
    <div className='top-container'>
      <div className='image-container'>
        <VodaPayClubTicket />
      </div>
      <h2 className='title'>Join the VodaPay Club</h2>
      <div className='join-club-container'>
        <div className='join-club-child-container'>
          <div className='join-club-sub-child-container'>
            <div className='icon'>
              <TagIcon />
              <div className='text'>
                <span className='subtext-header'>Exclusive deals picked just for you</span>
                <span className='subtext'>Get more value & premium vouchers</span>
              </div>
            </div>
            <div className='percent-icon'>
              <PercentIcon />
              <div className='text'>
                <span className='subtext-header'>Enjoy up to 50% more</span>
                <span className='subtext'>VodaPay Club members get more value</span>
              </div>
            </div>
            <div className='icon'>
              <MerchantIcon />
              <div className='text'>
                <span className='subtext-header'>VIP access to the VodaPay Club</span>
                <span className='subtext'>Shop premium brands at the best prices</span>
              </div>
            </div>
          </div>
        </div>
        {
          subscriptionDetails?.plans?.length === 1
            ? <span className='autoRenewText'>Auto renews at <strong>R{subscriptionDetails?.plans[0]?.price}/Month</strong>. You can cancel at any time.</span>
            : null
        }
        <button
          className={ buttonCss }
          onClick={
            () => {
              handleContinue(subscriptionStatus);
              onClickAnalytics();
            }
          }
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}
